import axios from 'axios';
import { API_BASE } from './config';

/**
 * Estimate transaction fee
 * @param blockchain Blockchain name (e.g., ethereum, bitcoin)
 * @param from Sender address
 * @param to Recipient address
 * @param amount Transaction amount
 * @param speed Transaction speed (slow, medium, fast)
 * @param token Optional token address for token transfers
 * @returns Fee estimation result
 */
export const estimateFee = async (
  blockchain: string,
  from: string,
  to: string,
  amount: string,
  speed: 'slow' | 'medium' | 'fast' = 'medium',
  token?: string
) => {
  try {
    const response = await axios.post(`${API_BASE}/fee/estimate`, {
      blockchain,
      from,
      to,
      amount,
      speed,
      ...(token ? { token } : {})
    });
    
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw new Error(error.response.data?.error || 'Failed to estimate fee');
    }
    throw error;
  }
};
